import workflowApi from '../api/workflow/workflow'
import outboxApi from '@/api/outbox/outbox'
import { WORKFLOW_ACTION_TYPE, APP_CODE_STATUS, WORKFLOW_META_KEY, FILTER_STATUS_ID, OLD_WORKITEM_STATUS, WORKFLOW_STATUS, SECURITY_LEVEL } from '../constant/constant'
import { globalModule, workflowModule, commonComponentModule } from '@/store/moduleName'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { getArraySorter, isArrayEmptyOrNull } from '@/utils/arrayUtil'
import { isFieldBlank } from '@/utils/stringUtil'
// import { get } from '@/utils/objectUtil'
import { TASK_LIST_JOB_TYPE, BUSINESS_CODE, LOCAL_STORAGE_KEY } from '@/constant/constant'
import { getStorage } from '@/utils/storageUtil'
import { parseJwt } from '@/utils/utils'
// import { timestampToYyyyMmDdHhMmSs } from '../utils/datetimeUtil'
// import { windowLocation } from '../utils/urlUtil'

export const taskMethod = {
  data: function () {
    return {
      SECURITY_LEVEL,
      entityAdministrativeSupportRelation: [],
      isApp: process.env.VUE_APP_MODE === 'APP',
      myEuid: parseJwt(getStorage('g2e-jwt-token')).euid,
      myEntityId: parseJwt(getStorage('g2e-jwt-token')).entity_id
    }
  },
  created () {
  },
  methods: {
    getSecurityLevel (taskProp) {
      if (taskProp.securityLevelId === SECURITY_LEVEL.SECRET) {
        return this.$t('encrypt.level.a')
      } else if (taskProp.securityLevelId === SECURITY_LEVEL.CONFIDENTIAL) {
        return this.$t('encrypt.level.b')
      } else if (taskProp.securityLevelId === SECURITY_LEVEL.TOP_CONFIDENTIAL) {
        return this.$t('encrypt.level.c')
      }
    },
    getEntityAdministrativeSupportRelation: function () {
      outboxApi.getEntityAdministrativeSupportRelation(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.entityAdministrativeSupportRelation = resp.data
        }
      })
    },
    massageActiveList: function (list) {
      let downloadUrl = workflowApi.downloadPdfFromOssUrl
      // if (DMS_BUSINESS_CODE.includes(this.businessCode)) {
      //   downloadUrl = workflowApi.getPdfFromDmsUrl
      // }
      list.forEach(item => {
        item.status = false
        item.newMessage = null
        item.opinion = this.$chPtObjData('defaultCommentChinDesc', item)
        item.show = false
        item.isNewApplicant = true
        if (this.businessCode !== BUSINESS_CODE.OFICIO) {
          item.pdfInitParams = {
            url: downloadUrl + item.id + '/' + item.formAttribute.formCode,
            httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
            withCredentials: true,
            CMapReaderFactory
          }
        }
      })
    },
    massageHistoryList: function (list) {
      let downloadUrl = workflowApi.downloadPdfFromOssUrl
      list.forEach(item => {
        if (this.businessCode !== BUSINESS_CODE.OFICIO) {
          item.pdfInitParams = {
            url: downloadUrl + item.id + '/' + item.formAttribute.formCode,
            httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
            withCredentials: true,
            CMapReaderFactory
          }
        }
        if (item.status !== WORKFLOW_STATUS.ACTIVE) {
          let actionMetas = item.formMetaList.filter(meta => meta.formMetaKey === 'action')
          if (isArrayEmptyOrNull(actionMetas)) {
            item.actionTypeId = null
          } else {
            actionMetas.sort(getArraySorter('id', false))
            item.actionTypeId = parseInt(actionMetas[0].formMetaValue)
          }
        }
      })
    },
    isApprove: function (status) {
      return status === true
    },
    async refreshTaskListCount () {
      await this.$store.dispatch(workflowModule + '/countBwItems')
      this.$store.dispatch(workflowModule + '/countPersonalItems')
      this.$store.dispatch(workflowModule + '/countGroupItems')
      this.$store.dispatch(workflowModule + '/countAttentionItems')
    },
    refreshTaskList: async function (ownerEuid, businessCode) {
      if (this.jobType === TASK_LIST_JOB_TYPE.MY_JOB) {
        this.taskList = []
        // await this.$store.dispatch(workflowModule + '/getActiveItems', businessCode)
        this.getActiveItems()
      } else if (this.jobType === TASK_LIST_JOB_TYPE.GROUP_JOB) {
        this.taskList = []
        this.getGroupItems()
        this.$refs.groupSelector.refreshCnt()
      } else if (this.jobType === TASK_LIST_JOB_TYPE.ATTENTION_JOB) {
        this.getGenAttentionActiveItems()
        // if (this.enableFilter) {
        //   this.getGenAttentionActiveItems()
        // } else {
        //   await this.$store.dispatch(workflowModule + '/getAttentionActiveItems', { 'businessCode': businessCode, 'euid': ownerEuid })
        // }
        this.$refs.attentionStaffSelector.refresh()
      }
      // this.loading = false
      this.refreshTaskListCount()
    },
    transferTaskToStaff: function (task, event, taskListProp) {
      Object.assign(task, event)
      let formMeta = this.genFormMeta(task, taskListProp, this.currGroupId)
      task.show = false
      formMeta.privateMessage = task.newMessage

      if (event.isRollback) {
        formMeta.oldWorkItemStatus = OLD_WORKITEM_STATUS.ROLLBACK
        formMeta.message = this.$t('TaskList.Rollback.SystemMessage')
      } else {
        formMeta.oldWorkItemStatus = OLD_WORKITEM_STATUS.TRANSFER
        formMeta.message = this.$t('TaskList.Transfer.SystemMessage')
      }
      // console.log(formMeta)
      let cb = resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('TaskList.Transfer.SuccessMessage'))
          this.refreshTaskList(task.assignedToEuid, task.formAttribute.businessCode)
        }
        this.loading = false
      }
      workflowApi.transferTask(cb, task.id, formMeta)
    },
    // Deprecated
    rollbackTask: function (task, formMeta) {
      task.show = false
      if (!formMeta) {
        formMeta = {
        }
      }
      formMeta.privateMessage = task.newMessage
      formMeta.message = this.$t('TaskList.Rollback.SystemMessage')
      workflowApi.rollbackTask(task.id, formMeta, cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('TaskList.Rollback.SuccessMessage'))
          this.refreshTaskList(task.assignedToEuid, task.formAttribute.businessCode)
        }
        this.loading = false
      })
    },
    agreeToNextStaff: function (task, formMeta) {
      workflowApi.completeWithNextStaff(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.refreshTaskList(task.assignedToEuid, task.formAttribute.businessCode)
        }
      }, task.id, WORKFLOW_ACTION_TYPE.AGREE, formMeta)
    },
    cancelWorkItem: function (task, formMeta) {
      let body = {
        appStatusCode: APP_CODE_STATUS[WORKFLOW_ACTION_TYPE.CANCEL]
        // modifiedBy: staff.staffCode,
        // modifiedTime: timestampToYyyyMmDdHhMmSs(Date.now())
      }

      if (formMeta) {
        body = { ...body, ...formMeta }
      }

      workflowApi.completeAutoFindNextStaff(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('TaskList.Cancel.SuccessMessage'))
          this.refreshTaskList(task.assignedToEuid, task.formAttribute.businessCode)
        }
      }, task.id, WORKFLOW_ACTION_TYPE.CANCEL, body)
    },
    getPdfFromDms: async function (item) {
      let content = null
      let blob = null
      let url = null
      const fileName = 'document.pdf'
      await workflowApi.getPdfFromDms(cb => {
        content = cb
        blob = new Blob([content], { type: 'application/pdf' })
        url = URL.createObjectURL(blob)
        // window.open(url)
      }, item.id, item.formAttribute.formCode)
      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE/Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        window.open(url)
      }
      // windowLocation(url, blob)
    },

    // download pdf from OSS or DMS
    getPdfFromOss: async function (item) {
      let content = null
      let blob = null
      let url = null
      const fileName = 'document.pdf'
      await workflowApi.getPdfFromOss(cb => {
        content = cb
        blob = new Blob([content], { type: 'application/pdf' })
        url = URL.createObjectURL(blob)
        // window.open(url)
      }, item.id, item.formAttribute.formCode)
      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE/Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        window.open(url)
      }
      // windowLocation(url, blob)
    },
    genTaskProp (task) {
      let taskListProp = {
        id: task.id,
        show: false,
        receiveEntities: [],
        ccEntities: [],
        isCarbonCopyAttachments: false,
        editMode: false,
        isUrgent: false,
        isDirectSendToEDocX: false,
        issueEntityId: null,
        issueEntityChinName: null,
        issueEntityPortName: null,
        issueSubunitEntityId: null,
        approverEuid: null,
        isEncryptedDoc: false,
        isMeOpener: false,
        securityLevelId: null,
        openerList: [] // self department users who can open encrypted attachment
      }
      if (task.formMetaList) {
        task.formMetaList.forEach(meta => {
          if (meta.formMetaKey === WORKFLOW_META_KEY.IS_URGENT) {
            taskListProp.isUrgent = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX) {
            taskListProp.isDirectSendToEDocX = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_ID) {
            taskListProp.issueEntityId = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_CHIN_NAME) {
            taskListProp.issueEntityChinName = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_PORT_NAME) {
            taskListProp.issueEntityPortName = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_ID) {
            taskListProp.issueSubunitEntityId = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.APPROVER_EUID) {
            taskListProp.approverEuid = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.IS_ENCRYPTED_DOC) {
            taskListProp.isEncryptedDoc = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.SECURITY_LEVEL_ID) {
            taskListProp.securityLevelId = JSON.parse(meta.formMetaValue)
          }
        })
      }
      if (taskListProp.isEncryptedDoc) {
        // filter out other dept's staff, only show self dept's staff
        task.formAttribute.attachmentList.every(attachment => {
          if (!isArrayEmptyOrNull(attachment.driveFileOpenerList)) {
            taskListProp.openerList = attachment.driveFileOpenerList.filter(o => o.entityId === this.myEntityId)
            return false
          }
          return true
        })

        task.formAttribute.attachmentList.every(attachment => {
          attachment.driveFileOpenerList.every(opener => {
            if (opener.euid === this.myEuid) {
              // 所有附件的本局開啟人應該是一樣的, 所以找到任意一份附件的開啟人名單包含當事人的 euid, 則可判定他是所有附件的開啟人
              taskListProp.isMeOpener = true
            }
            return !taskListProp.isMeOpener
          })
          return !taskListProp.isMeOpener
        })
      }
      outboxApi.oficioReceiveEntities(task.formAttribute.formIdentity, resp => {
        if (resp.status === 201 || resp.status === 200) {
          taskListProp.receiveEntities = resp.data
        }
      })
      outboxApi.oficioCarbonCopyEntities(task.formAttribute.formIdentity, resp => {
        if (resp.status === 201 || resp.status === 200) {
          taskListProp.ccEntities = resp.data
        }
      })
      outboxApi.oficioCarbonCopyOptions(task.formAttribute.formIdentity, resp => {
        if (resp.status === 201 || resp.status === 200) {
          taskListProp.isCarbonCopyAttachments = resp.data.isCarbonCopyAttachments
        }
      })
      return taskListProp
    },
    genIssueEntity (task) {
      let issueEntity = {
        issueEntityId: null,
        issueEntityAbbr: null,
        issueEntityChinName: null,
        issueEntityPortName: null,
        issueSubunitEntityId: null,
        issueSubunitEntityAbbr: null,
        issueSubunitEntityChinName: null,
        issueSubunitEntityPortName: null
      }
      if (task.formMetaList) {
        task.formMetaList.forEach(meta => {
          if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_ID) {
            issueEntity.issueEntityId = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_ABBR) {
            issueEntity.issueEntityAbbr = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_CHIN_NAME) {
            issueEntity.issueEntityChinName = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_PORT_NAME) {
            issueEntity.issueEntityPortName = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_ID) {
            issueEntity.issueSubunitEntityId = JSON.parse(meta.formMetaValue)
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_ABBR) {
            issueEntity.issueSubunitEntityAbbr = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_CHIN_NAME) {
            issueEntity.issueSubunitEntityChinName = meta.formMetaValue
          } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_PORT_NAME) {
            issueEntity.issueSubunitEntityPortName = meta.formMetaValue
          }
        })
      }
      return issueEntity
    },
    genTaskListProps (taskList) {
      // console.log(taskList)
      this.taskListProps = []
      // this.issueEntities = []
      // let issueSubunitEntityIds = []
      for (let i = 0; i < taskList.length; i++) {
        let taskProp = this.genTaskProp(taskList[i])
        this.taskListProps.push(taskProp)
        // let issueEntity = this.genIssueEntity(taskList[i])
        // if (issueEntity.issueSubunitEntityId) {
        //   if (!issueSubunitEntityIds.includes(issueEntity.issueSubunitEntityId)) {
        //     issueSubunitEntityIds.push(issueEntity.issueSubunitEntityId)
        //     this.issueEntities.push(issueEntity)
        //   }
        // }
        // const e = taskList[i]
        // this.taskListProps.push({
        //   id: e.id,
        //   show: false,
        //   receiveEntities: [],
        //   editMode: false,
        //   isUrgent: false,
        //   isDirectSendToEDocX: false,
        //   issueEntityId: null,
        //   issueSubunitEntityId: null
        // })
        // if (e.formMetaList) {
        //   let issueEntity = {
        //     issueEntityId: null,
        //     issueEntityAbbr: null,
        //     issueEntityChinName: null,
        //     issueEntityPortName: null,
        //     issueSubunitEntityId: null,
        //     issueSubunitEntityAbbr: null,
        //     issueSubunitEntityChinName: null,
        //     issueSubunitEntityPortName: null
        //   }
        //   e.formMetaList.forEach(meta => {
        //     if (meta.formMetaKey === WORKFLOW_META_KEY.IS_URGENT) {
        //       this.taskListProps[i].isUrgent = JSON.parse(meta.formMetaValue)
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX) {
        //       this.taskListProps[i].isDirectSendToEDocX = JSON.parse(meta.formMetaValue)
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_ID) {
        //       issueEntity.issueEntityId = JSON.parse(meta.formMetaValue)
        //       this.taskListProps[i].issueEntityId = JSON.parse(meta.formMetaValue)
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_ABBR) {
        //       issueEntity.issueEntityAbbr = meta.formMetaValue
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_CHIN_NAME) {
        //       issueEntity.issueEntityChinName = meta.formMetaValue
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_ENTITY_PORT_NAME) {
        //       issueEntity.issueEntityPortName = meta.formMetaValue
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_ID) {
        //       issueEntity.issueSubunitEntityId = JSON.parse(meta.formMetaValue)
        //       this.taskListProps[i].issueSubunitEntityId = JSON.parse(meta.formMetaValue)
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_ABBR) {
        //       issueEntity.issueSubunitEntityAbbr = meta.formMetaValue
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_CHIN_NAME) {
        //       issueEntity.issueSubunitEntityChinName = meta.formMetaValue
        //     } else if (meta.formMetaKey === WORKFLOW_META_KEY.ISSUE_SUBUNIT_ENTITY_PORT_NAME) {
        //       issueEntity.issueSubunitEntityPortName = meta.formMetaValue
        //     }
        //   })
        //   if (issueEntity.issueEntityId) {
        //     if (!issueEntityIds.includes(issueEntity.issueEntityId)) {
        //       issueEntityIds.push(issueEntity.issueEntityId)
        //       this.issueEntities.push(issueEntity)
        //     }
        //   }
        // }
        // outboxApi.oficioReceiveEntities(e.formAttribute.formIdentity, resp => {
        //   if (resp.status === 201 || resp.status === 200) {
        //     this.taskListProps[i].receiveEntities = resp.data
        //   }
        // })
      }
    },
    // for preview task list files
    previewFileList (oficioId, data) {
      outboxApi.previewOficioFileListByInstanceCodes(oficioId, data, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.files = []
          let respData = resp.data
          respData.sort(getArraySorter('listOrder', true))
          for (let i = 0; i < respData.length; i++) {
            const e = respData[i]
            let pdfInitParams = {
              url: this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/downloadFile?instanceCode=' + e.documentCode,
              httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
              withCredentials: true,
              CMapReaderFactory
            }
            e.url = pdfInitParams
            this.files.push(e)
          }
          this.dialog = true
        }
      })
    },
    async resetFileKey (task) {
      let data = []
      let docKeyObj = null
      this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
      for (let i = 0; i < task.formAttribute.attachmentList.length; i++) {
        const e = task.formAttribute.attachmentList[i]
        data.push(e.documentId)
        // get the encrypted file key
        if (!isArrayEmptyOrNull(e.driveFileOpenerList)) {
          for (const opener of e.driveFileOpenerList) {
            if (docKeyObj === null && opener.euid === this.myEuid) {
              await workflowApi.getDocumentKey(resp => {
                if (resp.status === 201 || resp.status === 200) {
                  docKeyObj = resp.data
                }
              }, opener.docCode, opener.euid)
            }
          }
        }
      }
      if (docKeyObj !== null) {
        this.$store.commit(commonComponentModule + '/setEncryptedFileKey', docKeyObj.openerKey)
        this.$store.commit(commonComponentModule + '/setKeyPairId', docKeyObj.keyPairId)
      } else {
        this.$store.commit(commonComponentModule + '/setKeyPairId', -1)
      }
      return data
    },
    // for preview task list files
    async previewOficioFileList (task) {
      let data = await this.resetFileKey(task)
      // console.log(data)
      this.previewFileList(task.formAttribute.formIdentity, data)
    },
    // for preview task list files
    previewRefFileList (task) {
      let data = []
      for (let i = 0; i < task.formAttribute.referenceDocumentList.length; i++) {
        const e = task.formAttribute.referenceDocumentList[i]
        data.push(e.documentId)
      }
      this.previewFileList(task.formAttribute.formIdentity, data)
    },

    previewGeneralFileList (task) {
      this.files = []
      let e = {}
      let pdfInitParams = {
        url: workflowApi.downloadPdfFromOssUrl + task.id + '/' + task.formAttribute.formCode,
        httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
        withCredentials: true,
        CMapReaderFactory
      }
      e.displayName = 'applicationForm'
      e.fileExtension = 'pdf'
      // console.log(i + ' || ' + e.displayName + ' ||  ' + e.fileExtension)
      e.url = pdfInitParams
      this.files.push(e)

      // attachments
      if (task.formAttribute.attachmentList && task.formAttribute.attachmentList.length) {
        for (const a of task.formAttribute.attachmentList) {
          // pdfInitParams['url'] = workflowApi.downloadPdfFromOssUrl + task.id + '/' + a.documentId
          pdfInitParams = {
            url: workflowApi.downloadPdfFromOssUrl + task.id + '/' + a.documentId,
            httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
            withCredentials: true,
            CMapReaderFactory
          }
          e = {}
          e.displayName = a.displayName
          e.fileExtension = a.fileName.substring(a.fileName.lastIndexOf('.') + 1)
          e.url = pdfInitParams
          this.files.push(e)
        }
      }

      this.dialog = true
    },

    genFormMeta (task, taskProp, currentGroupId) {
      let msg = task.opinion
      // if (taskProp.isUrgent) {
      //   msg = msg + ' (' + this.$t('Outbox.Urgent') + ')'
      // }
      // if (taskProp.isDirectSendToEDocX) {
      //   msg = msg + ' (' + this.$t('Outbox.DirectSendAfterSign') + ')'
      // }
      let formMeta = {
        message: msg
      }
      // let recordType = get(task, 'nextStaffObj.recordType')
      // if (recordType && (recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
      if (task.defaultNextEuid && !task.defaultNextEuid.startsWith('E')) {
        formMeta.assignedToGroupId = task.defaultNextEuid
      } else {
        // change for euid
        formMeta.assignedToEuid = task.defaultNextEuid
      }
      if (currentGroupId) {
        formMeta.completedByGroupId = currentGroupId
      }
      if (taskProp) {
        formMeta.isUrgent = taskProp.isUrgent
        formMeta.parameter1 = taskProp.isDirectSendToEDocX
      }
      return formMeta
    },
    filterTask (task, taskListProp, filterSubunitId, filterText, filterStatusId) {
      let subunitPass = (!filterSubunitId || (taskListProp.issueSubunitEntityId === filterSubunitId))
      let filterTextPass = (isFieldBlank(filterText) ||
                              this.$chPtObjData('chinTaskListTitle', task.formAttribute).includes(filterText) ||
                              this.$chPtObjData('chinTaskListDesc1', task.formAttribute).includes(filterText) ||
                              this.$chPtObjData('chinTaskListDesc2', task.formAttribute).includes(filterText))
      let statusId = null
      // if (task.status === 'H' && task.actionTypeId === 2) {
      if (task.status !== 'A' && task.actionTypeId === 2) {
        statusId = FILTER_STATUS_ID.SIGNED
      // } else if (task.status === 'H' && task.actionTypeId === 3) {
      } else if (task.status !== 'A' && (task.actionTypeId === 3)) {
        statusId = FILTER_STATUS_ID.CANCELED
      } else {
        statusId = FILTER_STATUS_ID.PROCESSING
      }
      let filterStatusPass = (!filterStatusId ||
                                (filterStatusId === FILTER_STATUS_ID.ALL) ||
                                (statusId === filterStatusId))
      return subunitPass && filterTextPass && filterStatusPass
    },
    filterTaskList (...args) {
      this.page = 1
      const [filterSubunitId, filterText, filterStatusId] = args
      this.filteredTaskList = []
      this.filteredTaskListProps = []
      for (let i = 0; i < this.taskList.length; i++) {
        let task = this.taskList[i]
        let taskListProp = this.taskListProps[i]
        if (this.filterTask(task, taskListProp, filterSubunitId, filterText, filterStatusId)) {
          this.filteredTaskList.push(task)
          this.filteredTaskListProps.push(taskListProp)
        }
      }
    },
    onSearchIconClick (isShow) {
      if (isShow) {
        this.$refs.filterBox.focus()
      } else {
        this.filterTaskList()
      }
    },
    onServerSearchIconClick (isShow) {
      if (isShow) {
        this.$refs.filterBox.focus()
      } /* else {
        this.filterText = ''
        this.$refs.filterBox.clear()
      } */
    },
    updateTaskListDefaultNextStaff: function () {
      this.taskList.forEach(task => {
        if (!task.defaultNextEuid) {
          task.defaultNextEuid = this.defaultNextStaff
        }
      })
    },
    askWhetherCancelTask: function (task, taskProp) {
      this.currentTask = task
      this.currentTaskProp = taskProp
      this.isShowCancelTaskDialog = true
    },
    askWhetherAgreeTask: function (task, taskProp) {
      if (!task.defaultNextEuid) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.NextStaff')]))
        return false
      }
      this.currentTask = task
      this.currentTaskProp = taskProp
      this.isShowAgreeTaskDialog = true
    },
    // updateOutbox () {
    //   outboxApi.updateOficioIsUrgent(this.currentTaskProp.isUrgent, this.currentTask.formAttribute.formIdentity, resp => {})
    //   outboxApi.updateOficioIsDirectSendToEDocX(this.currentTaskProp.isDirectSendToEDocX, this.currentTask.formAttribute.formIdentity, resp => {})
    // },
    confirmDelete () {
      this.loading = true
      this.currentTask.opinion = this.cancelReason
      this.cancelWorkItem(this.currentTask, this.genFormMeta(this.currentTask, this.currentTaskProp, this.currGroupId))
      // this.updateOutbox()
    },
    confirmAgree () {
      this.loading = true
      this.agreeToNextStaff(this.currentTask, this.genFormMeta(this.currentTask, this.currentTaskProp, this.currGroupId))
      // this.updateOutbox()
    },
    recallJob (cb, task) {
      this.waiting = true
      // console.log('recallJob')
      let formMeta = {
      }
      formMeta.privateMessage = task.newMessage
      formMeta.message = this.$t('TaskList.TakeBack.SystemMessage')
      workflowApi.recallTask(resp => {
        this.waiting = false
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          cb()
          // this.$router.push('/tasklist/outboxList')
        }
      }, task.id, formMeta)
    },
    search (val) {
      this.filterText = val
      this.handlePageChange(1)
    },
    async getActiveItems () {
      this.loading = true
      let metas = []
      if (this.businessCode === BUSINESS_CODE.OFICIO) {
        metas = [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX]
      }
      await workflowApi.personalActiveWorkItemsWithPaging(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.totalPage = resp.data.pages
          this.massageActiveList(resp.data.list)
          if (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN) {
            this.genTaskListProps(resp.data.list)
          }
          this.taskList = resp.data.list
        }
      }, this.filterText, this.page, this.itemsPerPage, this.businessCode, metas)
      this.loading = false
    },
    async getGroupItems () {
      this.loading = true
      let metas = []
      if (this.businessCode === BUSINESS_CODE.OFICIO) {
        metas = [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX]
      }
      await workflowApi.groupActiveWorkItemsWithPaging(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.totalPage = resp.data.pages
          this.massageActiveList(resp.data.list)
          if (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN) {
            this.genTaskListProps(resp.data.list)
          }
          this.taskList = resp.data.list
        }
      }, this.filterText, this.page, this.itemsPerPage, this.businessCode, this.currGroupId, metas)
      this.loading = false
    },
    async getHistoryItems () {
      this.loading = true
      let metas = []
      if (this.businessCode === BUSINESS_CODE.OFICIO) {
        metas = [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX]
      }
      await workflowApi.personalHistoryWorkItemsWithPaging(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.totalPage = resp.data.pages
          this.massageHistoryList(resp.data.list)
          if (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN) {
            this.genTaskListProps(resp.data.list)
          }
          this.taskList = resp.data.list
        }
      }, this.filterText, this.page, this.itemsPerPage, this.businessCode, metas)
      this.loading = false
    },
    async getGroupHistoryItems () {
      if (this.currGroupId) {
        this.loading = true
        let metas = []
        if (this.businessCode === BUSINESS_CODE.OFICIO) {
          metas = [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX]
        }
        // await this.$store.dispatch(workflowModule + '/getGroupHistoryItems', { businessCode: this.businessCode, groupId: this.currGroupId })
        await workflowApi.groupHistoryWorkItemsWithPaging(resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.totalPage = resp.data.pages
            this.massageHistoryList(resp.data.list)
            if (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN) {
              this.genTaskListProps(resp.data.list)
            }
            this.taskList = resp.data.list
          }
        }, this.filterText, this.page, this.itemsPerPage, this.businessCode, this.currGroupId, metas)
        this.loading = false
      }
    },
    async getGenAttentionActiveItems () {
      this.loading = true
      await workflowApi.getFollowingStaffTasksWithPaging(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.totalPage = resp.data.pages
          this.massageActiveList(resp.data.list)
          if (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN) {
            this.genTaskListProps(resp.data.list)
          }
          this.ofcTaskList = resp.data.list
        }
      }, this.filterText, this.page, this.itemsPerPage, this.businessCode, this.currAttentionStaffEuid)
      this.loading = false
    },
    isShowPdfButton () {
      if (this.isApp && this.businessCode === BUSINESS_CODE.LEAVE_MARK) {
        return false
      }

      return true
    }
  },
  computed: {
    // issueEntitiesWithAll () {
    //   return [{
    //     issueEntityId: null,
    //     issueEntityAbbr: null,
    //     issueEntityChinName: null,
    //     issueEntityPortName: null,
    //     issueSubunitEntityId: null,
    //     issueSubunitEntityAbbr: null,
    //     issueSubunitEntityChinName: '所有',
    //     issueSubunitEntityPortName: 'Todos'
    //   }, ...this.issueEntities]
    // }
  }
}
